import React from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import { SvgIconProps } from '@material-ui/core/SvgIcon'
import { TopNavKey } from './topNav'
import allLink, { LinkKey } from './link'

interface PropTypes {
  classes: Record<'icon', string>
  topNavKey: TopNavKey
  icon: React.ComponentType<SvgIconProps>
  title: string
  subItem: LinkKey
}

const LinkTopNav: React.FC<PropTypes> = (props) => {
  const { classes, icon: Icon, title, subItem } = props
  return (
    <Tooltip title={title}>
      <IconButton
        component="a"
        href={allLink[subItem].href}
        target={allLink[subItem].blank ? '_blank' : '_self'}
      >
        <Icon className={classes.icon} />
      </IconButton>
    </Tooltip>

  )
}

export default React.memo(LinkTopNav)
